import { UserRole } from "./userRole";

export class User {
    firstName: string;
    middleName: string;
    lastName: string;
    displayName: string;
    newEmail: string;
    email: string;
    confirmEmail: string;
    confirmNewEmail: string;
    password: string;
    confirmPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    preferredLanguage: string;
    otp: string;
    pkiuser: string;
    signinURL: string;
    isRoleAdmin: boolean;
    guid: string;
    createdDate: string;
    operation: string;
    roleAssigned: string;
    accountStatus: string;
    emailVerified: string;
    emailAccess: boolean;
    temporaryPassword: string;
    roleAssignmentEmail: number;
    
    roles: UserRole[];


    constructor() {
    }

    getRoles(): string {
        if (this.roles && this.roles.length > 0)
            return this.roles.map(r => r.roleName).join(", ");
        else 
            return "";
    }

}